<script>
import { Line } from "vue-chartjs";

export default {
  name: "LineChart",
  extends: Line,
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      handler(newData) {
        this.$data._chart.destroy();
        this.renderChart(newData, this.options);
      },
      deep: true,
    },
    options: {
      handler(newOptions) {
        this.$data._chart.destroy();
        this.renderChart(this.chartData, newOptions);
      },
      deep: true,
    },
  },
};
</script>
